// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__13KJU","title":"Info_title__FafQ-","selects":"Info_selects__16zdK","requiredAsterisk":"Info_requiredAsterisk___Kkc6"};